import { Component, HostListener, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { CookieService } from '../../services/cookie.service';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [TranslocoModule, FormsModule],
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
})
export class CookieBannerComponent implements OnInit {
  readonly cookieService = inject(CookieService);

  allowRequiredCookies = true;
  allowAnalyticsCookies = true;
  isExpanded = false;
  showBanner = true;
  currentWidth = 0;

  ngOnInit(): void {
    this.currentWidth = window.innerWidth;
    this.showBanner = !this.cookieService.getCookie('ls_allow_analytics');
  }

  setCookiePreferences(): void {
    const cookieValue = this.allowAnalyticsCookies ? 'true' : 'false';
    this.cookieService.setCookie('ls_allow_analytics', cookieValue, 30);
    this.showBanner = false;
  }

  toggleBanner(): void {
    this.isExpanded = !this.isExpanded;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.currentWidth = window.innerWidth;
  }

  get buttonSize(): string {
    return this.currentWidth > 865 ? 'md' : 'sm';
  }
}
